import { render, staticRenderFns } from "./ForgotPassForm.vue?vue&type=template&id=2ab9df09&scoped=true"
import script from "./ForgotPassForm.vue?vue&type=script&lang=js"
export * from "./ForgotPassForm.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassForm.vue?vue&type=style&index=0&id=2ab9df09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9df09",
  null
  
)

export default component.exports